import { IWizardTabExpose, IWizardTabProps } from "@/components/ui/wizard/wizard-tab.types";
import { TComponent } from "@/utils/component-utils";

import WizardTab from "@/components/ui/wizard/wizard-tab.vue";

export enum EWizardCloseState {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
  ABANDONED = "ABANDONED",
}

export const WizardInject = Symbol("WizardInject");

export interface IWizardOptBtnOpts {
  label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick: () => any;
}

export interface IWizardInject {
  addTab(item: TComponent<typeof WizardTab, IWizardTabProps, IWizardTabExpose>): void;
  removeTab(item: TComponent<typeof WizardTab, IWizardTabProps, IWizardTabExpose>): void;
  focusNextTab(): Promise<void>;
  focusPrevTab(): void;
  setNextDisabled(nextDisabled: boolean): void;
  setPreviousDisabled(nextDisabled: boolean): void;
  setOptionalButton(opts: IWizardOptBtnOpts): void;
  removeOptionalButton(): void;
  hideBackButton(): void;
  showBackButton(): void;
  closeWizard(state: EWizardCloseState): void;
  finishWizard(): void;
}
